<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="v_tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="333"
      border
      :edit-rules="validRules"
      @edit-closed="onEditClosed"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('group_title_freight_deduction_item') || '扣款费用明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="removeRow()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:expense="{ row }">
        <expense-select
          v-model="row.expenseCode"
          filterable
          clearable
          :body="{ expenseBizType: 'B' }"
          :placeholder="$l('form_placeholder_expenseType') || '请选择项目费用'"
          @change="
            (value, item) => expenseChange({ val: { value, item }, row })
          "
        />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
export default {
  props: {
    disabled: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      v_tableData: [],
      tableColumns: tableColumns(this),
      validRules: {
        expenseName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_expenseType') || '请选择项目费用',
          },
        ],
        currencyTotalAmount: [
          {
            type: 'number',
            required: true,
            message:
              this.$l('form_placeholder_currency_Amount') ||
              '请输入扣款金额...',
          },
        ],
      },
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = e || []
      },
      immediate: true,
    },
  },
  methods: {
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt({}, -1)
      await $itemTable.setActiveCell(newRow, 'expenseName')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.subTotAmount()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const data = this.getTableData()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('tips_add_expense_item') || '请添加费用明细',
          type: 'warning',
        })
        return false
      }


      this.subTotAmount()
      let result = await this.$refs.itemTable.validate(true)
      return !result
    },
    async removeRow() {
      await this.$refs.itemTable.removeCheckboxRow()
      this.subTotAmount()
    },
    async subTotAmount() {
      const data = this.getTableData()
      const totAmount = data.reduce(
        (result, next) => add(result, next.currencyTotalAmount),
        0
      )
      this.$emit('updateTotAmount', totAmount)
    },
    onEditClosed() {
      this.subTotAmount()
    },
    expenseChange({ val, row }) {
      const { item } = val || {}
      const { expenseCode, expenseName, expenseType, v_expenseType } =
        item || {}
      row.expenseCode = expenseCode
      row.expenseName = expenseName
      row.expenseType = expenseType
      row.v_expenseType = v_expenseType
    },
  },
}
</script>
